import { useSimilarOffers } from '../hooks/useSimilarOffers';
import { isUserLoggedIn } from '../utils/auth';
import OfferDisplay from './OfferDisplay';
import OfferList from './OfferList';
import '../scss/similar-offers-list.scss';

interface Props {
  offer: string;
}

const SimilarOffers: React.FC<Props> = ({ offer }) => {
  const isLoggedIn = isUserLoggedIn();
  const { data: similarOffers, isLoading } = useSimilarOffers(offer);

  const showContent = !isLoading && similarOffers && similarOffers.length > 0;

  return (
    <>
      {showContent && (
        <section className="similar-offers-list mb-3">
          <h3 className="font-yettel-bold fz-22 mb-3">Slične ponude</h3>
          <OfferList>
            {similarOffers.map(offer => (
              <OfferDisplay
                key={offer.id}
                offer={offer}
                isUserLoggedIn={isLoggedIn}
                imgFetchPriority="high"
                imgLoadingType="eager"
                displayedIn="Slične ponude"
              />
            ))}
          </OfferList>
        </section>
      )}
    </>
  );
};

export default SimilarOffers;
